'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.handleRetry = () => {
            var _a, _b;
            this.setState({ hasError: false, error: null });
            (_b = (_a = this.props).onRetry) === null || _b === void 0 ? void 0 : _b.call(_a);
        };
        this.state = { hasError: false, error: null };
    }
    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }
    componentDidCatch(error, errorInfo) {
        var _a, _b;
        console.error('Widget error:', error, errorInfo);
        (_b = (_a = this.props).onError) === null || _b === void 0 ? void 0 : _b.call(_a, error, errorInfo);
    }
    render() {
        var _a;
        if (this.state.hasError) {
            if (this.props.fallback) {
                return this.props.fallback;
            }
            return (_jsxs("div", { className: "flex h-full w-full flex-col items-center justify-center gap-4 p-6 text-center", children: [_jsx("div", { className: "text-fg0 text-sm font-medium", children: "Something went wrong" }), _jsx("div", { className: "text-fg3 text-xs", children: (_a = this.state.error) === null || _a === void 0 ? void 0 : _a.message }), _jsx("button", { onClick: this.handleRetry, className: "bg-bg3 hover:bg-bg2 text-fg1 rounded-full px-4 py-2 text-xs font-medium transition-colors", children: "Try Again" })] }));
        }
        return this.props.children;
    }
}
